import React from 'react'
import LoveseatImage from '../../../../assets/products/loveseat-1-seat-1-back.webp'

const OneSeatOneBack = ({ totalWidth = '' }) => {
  return (
    <svg
      width="709"
      height="503"
      viewBox="0 -20 709 503"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <text x="320" y="50" fontSize="14" fill="#FFFFFF99">
        {totalWidth}
      </text>
      <image x="-310" y="-100" width="1080" height="760" xlinkHref={LoveseatImage} />
      <g id="Group 1502">
        <g id="E-Comp">
          <g filter="url(#filter0_d_5459_8525)">
            <rect
              id="E-Background"
              x="623.398"
              y="47.2333"
              width="41"
              height="41"
              rx="20.5"
              transform="rotate(146.495 623.398 47.2333)"
              fill="transparent"
            />
            <path
              id="E-Text"
              d="M599.656 45.899V47.9557H592.845V45.899H599.656ZM593.706 35.1588V47.9557H591.069V35.1588H593.706ZM598.769 40.3707V42.3746H592.845V40.3707H598.769ZM599.647 35.1588V37.2242H592.845V35.1588H599.647Z"
              fill="#FFFFFF99"
            />
          </g>
          <path
            id="E-Line"
            d="M572.49 74.2341C572.761 74.2891 573.025 74.1144 573.08 73.8438L573.977 69.434C574.032 69.1634 573.857 68.8995 573.586 68.8444C573.316 68.7894 573.052 68.9642 572.997 69.2348L572.2 73.1545L568.28 72.3574C568.009 72.3024 567.745 72.4771 567.69 72.7477C567.635 73.0183 567.81 73.2823 568.08 73.3374L572.49 74.2341ZM556.616 48.9748C556.346 48.9197 556.082 49.0945 556.027 49.3651L555.13 53.7748C555.075 54.0454 555.249 54.3094 555.52 54.3645C555.791 54.4195 556.055 54.2447 556.11 53.9741L556.907 50.0544L560.827 50.8515C561.097 50.9065 561.361 50.7317 561.416 50.4611C561.471 50.1905 561.296 49.9266 561.026 49.8715L556.616 48.9748ZM573.007 73.4681L571.667 71.4449L570.833 71.9969L572.173 74.0201L573.007 73.4681ZM568.988 67.3983L566.31 63.3517L565.476 63.9037L568.155 67.9503L568.988 67.3983ZM563.631 59.3052L560.952 55.2586L560.118 55.8106L562.797 59.8572L563.631 59.3052ZM558.273 51.212L556.933 49.1887L556.1 49.7407L557.439 51.764L558.273 51.212Z"
            fill="#FFFFFF99"
          />
        </g>
        <g id="D-Comp">
          <g filter="url(#filter1_d_5459_8525)">
            <rect
              id="D-Background"
              x="29.7339"
              y="167.353"
              width="41"
              height="41"
              rx="20.5"
              transform="rotate(-1.30105 29.7339 167.353)"
              fill="transparent"
            />
            <path
              id="D-Text"
              d="M49.9116 193.882H47.1255L47.1431 191.825H49.9116C50.603 191.825 51.186 191.67 51.6606 191.359C52.1353 191.043 52.4927 190.583 52.7329 189.98C52.979 189.376 53.1021 188.647 53.1021 187.791V187.167C53.1021 186.511 53.0317 185.934 52.8911 185.436C52.7563 184.938 52.5542 184.519 52.2847 184.179C52.0151 183.839 51.6841 183.584 51.2915 183.414C50.8989 183.238 50.4478 183.15 49.938 183.15H47.0728V181.085H49.938C50.7935 181.085 51.5757 181.232 52.2847 181.524C52.9995 181.812 53.6177 182.225 54.1392 182.764C54.6606 183.303 55.062 183.947 55.3433 184.697C55.6304 185.441 55.7739 186.271 55.7739 187.185V187.791C55.7739 188.699 55.6304 189.528 55.3433 190.278C55.062 191.028 54.6606 191.673 54.1392 192.212C53.6235 192.745 53.0054 193.158 52.2847 193.451C51.5698 193.738 50.7788 193.882 49.9116 193.882ZM48.6196 181.085V193.882H45.9829V181.085H48.6196Z"
              fill="#FFFFFF99"
            />
          </g>
          <path
            id="D-Line"
            d="M86.2907 131.614C86.0911 131.423 85.7746 131.43 85.5838 131.63L82.4749 134.883C82.2841 135.083 82.2913 135.399 82.491 135.59C82.6906 135.781 83.0071 135.774 83.1979 135.574L85.9614 132.682L88.8533 135.446C89.0529 135.636 89.3694 135.629 89.5602 135.43C89.751 135.23 89.7438 134.913 89.5442 134.723L86.2907 131.614ZM88.079 241.492C88.2786 241.683 88.5951 241.676 88.7859 241.476L91.8948 238.223C92.0856 238.023 92.0784 237.707 91.8787 237.516C91.6791 237.325 91.3626 237.332 91.1718 237.532L88.4083 240.424L85.5164 237.661C85.3168 237.47 85.0003 237.477 84.8095 237.677C84.6187 237.876 84.6259 238.193 84.8256 238.384L88.079 241.492ZM85.4454 131.987L85.5018 134.467L86.5015 134.445L86.4452 131.964L85.4454 131.987ZM85.6145 139.429L85.7272 144.391L86.7269 144.368L86.6142 139.406L85.6145 139.429ZM85.8398 149.352L85.9525 154.314L86.9523 154.291L86.8396 149.33L85.8398 149.352ZM86.0652 159.276L86.1779 164.237L87.1776 164.214L87.065 159.253L86.0652 159.276ZM86.2906 169.199L86.4033 174.16L87.403 174.138L87.2903 169.176L86.2906 169.199ZM86.516 179.122L86.6286 184.084L87.6284 184.061L87.5157 179.099L86.516 179.122ZM86.7413 189.045L86.854 194.007L87.8538 193.984L87.7411 189.023L86.7413 189.045ZM86.9667 198.969L87.0794 203.93L88.0791 203.907L87.9664 198.946L86.9667 198.969ZM87.1921 208.892L87.3048 213.853L88.3045 213.831L88.1918 208.869L87.1921 208.892ZM87.4174 218.815L87.5301 223.777L88.5299 223.754L88.4172 218.792L87.4174 218.815ZM87.6428 228.738L87.7555 233.7L88.7552 233.677L88.6426 228.716L87.6428 228.738ZM87.8682 238.661L87.9245 241.142L88.9243 241.12L88.8679 238.639L87.8682 238.661Z"
            fill="#FFFFFF99"
          />
        </g>
        <g id="C-Comp">
          <g filter="url(#filter2_d_5459_8525)">
            <rect
              id="C-Background"
              x="58.5176"
              y="364.025"
              width="41"
              height="41"
              rx="20.5"
              transform="rotate(-22.6637 58.5176 364.025)"
              fill="transparent"
            />
            <path
              id="C-Text"
              d="M88.0054 377.298H90.6333C90.5806 378.159 90.3433 378.924 89.9214 379.592C89.5054 380.26 88.9224 380.781 88.1724 381.156C87.4282 381.531 86.5317 381.719 85.4829 381.719C84.6626 381.719 83.9272 381.578 83.2769 381.297C82.6265 381.01 82.0698 380.6 81.6069 380.067C81.1499 379.533 80.8013 378.889 80.561 378.133C80.3208 377.377 80.2007 376.53 80.2007 375.593V374.705C80.2007 373.768 80.3237 372.921 80.5698 372.165C80.8218 371.404 81.1792 370.756 81.6421 370.223C82.1108 369.69 82.6704 369.279 83.3208 368.992C83.9712 368.705 84.6978 368.562 85.5005 368.562C86.5669 368.562 87.4663 368.755 88.1987 369.142C88.937 369.529 89.5083 370.062 89.9126 370.741C90.3228 371.421 90.5688 372.195 90.6509 373.062H88.0142C87.9849 372.546 87.8823 372.11 87.7065 371.752C87.5308 371.389 87.2642 371.116 86.9067 370.935C86.5552 370.747 86.0864 370.654 85.5005 370.654C85.061 370.654 84.6772 370.736 84.3491 370.9C84.021 371.064 83.7456 371.313 83.5229 371.647C83.3003 371.981 83.1333 372.403 83.022 372.912C82.9165 373.416 82.8638 374.008 82.8638 374.688V375.593C82.8638 376.255 82.9136 376.838 83.0132 377.342C83.1128 377.84 83.2651 378.262 83.4702 378.608C83.6812 378.947 83.9507 379.205 84.2788 379.381C84.6128 379.551 85.0142 379.636 85.4829 379.636C86.0337 379.636 86.4878 379.548 86.8452 379.372C87.2026 379.196 87.4751 378.936 87.6626 378.59C87.856 378.244 87.9702 377.814 88.0054 377.298Z"
              fill="#FFFFFF99"
            />
          </g>
          <path
            id="C-Line"
            d="M92.7887 297.253C92.5332 297.148 92.2411 297.27 92.1361 297.526L90.426 301.688C90.321 301.943 90.443 302.235 90.6984 302.34C90.9538 302.445 91.246 302.323 91.3509 302.068L92.8711 298.368L96.571 299.888C96.8264 299.993 97.1185 299.871 97.2235 299.616C97.3284 299.36 97.2064 299.068 96.951 298.963L92.7887 297.253ZM145.242 424.705C145.497 424.81 145.789 424.688 145.894 424.432L147.604 420.27C147.709 420.015 147.587 419.722 147.332 419.617C147.076 419.513 146.784 419.635 146.679 419.89L145.159 423.59L141.459 422.07C141.204 421.965 140.912 422.087 140.807 422.342C140.702 422.598 140.824 422.89 141.079 422.995L145.242 424.705ZM92.1372 297.908L93.0807 300.168L94.0035 299.782L93.06 297.523L92.1372 297.908ZM94.9676 304.686L96.8545 309.205L97.7773 308.82L95.8904 304.301L94.9676 304.686ZM98.7414 313.724L100.628 318.243L101.551 317.858L99.6642 313.339L98.7414 313.724ZM102.515 322.762L104.402 327.28L105.325 326.895L103.438 322.376L102.515 322.762ZM106.289 331.799L108.176 336.318L109.099 335.933L107.212 331.414L106.289 331.799ZM110.063 340.837L111.95 345.356L112.872 344.97L110.986 340.452L110.063 340.837ZM113.837 349.875L115.723 354.393L116.646 354.008L114.759 349.489L113.837 349.875ZM117.61 358.912L119.497 363.431L120.42 363.046L118.533 358.527L117.61 358.912ZM121.384 367.95L123.271 372.469L124.194 372.083L122.307 367.564L121.384 367.95ZM125.158 376.987L127.045 381.506L127.968 381.121L126.081 376.602L125.158 376.987ZM128.932 386.025L130.819 390.544L131.741 390.159L129.854 385.64L128.932 386.025ZM132.705 395.063L134.592 399.582L135.515 399.196L133.628 394.677L132.705 395.063ZM136.479 404.1L138.366 408.619L139.289 408.234L137.402 403.715L136.479 404.1ZM140.253 413.138L142.14 417.657L143.063 417.271L141.176 412.753L140.253 413.138ZM144.027 422.176L144.97 424.435L145.893 424.05L144.95 421.79L144.027 422.176Z"
            fill="#FFFFFF99"
          />
        </g>
        <g id="B-Comp">
          <g filter="url(#filter3_d_5459_8525)">
            <rect
              id="B-Background"
              x="379.044"
              y="466.321"
              width="41"
              height="41"
              rx="20.5"
              transform="rotate(-101.097 379.044 466.321)"
              fill="transparent"
            />
            <path
              id="B-Text"
              d="M395.619 443.142L392.332 443.142L392.314 441.332L395.074 441.332C395.561 441.332 395.959 441.27 396.27 441.147C396.58 441.018 396.812 440.834 396.964 440.594C397.122 440.348 397.201 440.049 397.201 439.697C397.201 439.299 397.125 438.976 396.973 438.73C396.826 438.484 396.595 438.306 396.278 438.194C395.968 438.083 395.566 438.027 395.074 438.027L393.246 438.027L393.246 448.759L390.609 448.759L390.609 435.962L395.074 435.962C395.818 435.962 396.483 436.032 397.069 436.173C397.661 436.313 398.162 436.527 398.572 436.814C398.982 437.101 399.296 437.465 399.513 437.904C399.729 438.338 399.838 438.853 399.838 439.451C399.838 439.978 399.718 440.465 399.478 440.91C399.243 441.355 398.871 441.719 398.361 442C397.857 442.281 397.198 442.436 396.384 442.466L395.619 443.142ZM395.505 448.759L391.611 448.759L392.64 446.702L395.505 446.702C395.968 446.702 396.346 446.629 396.639 446.482C396.932 446.33 397.148 446.125 397.289 445.867C397.43 445.609 397.5 445.313 397.5 444.979C397.5 444.604 397.436 444.279 397.307 444.004C397.184 443.728 396.984 443.517 396.709 443.371C396.434 443.219 396.07 443.142 395.619 443.142L393.079 443.142L393.097 441.332L396.261 441.332L396.867 442.044C397.646 442.032 398.273 442.17 398.748 442.457C399.229 442.738 399.577 443.104 399.794 443.556C400.017 444.007 400.128 444.49 400.128 445.006C400.128 445.826 399.949 446.517 399.592 447.08C399.234 447.637 398.71 448.056 398.019 448.337C397.333 448.618 396.495 448.759 395.505 448.759Z"
              fill="#FFFFFF99"
            />
          </g>
          <path
            id="B-Line"
            d="M181.615 446.599C181.461 446.828 181.522 447.139 181.751 447.293L185.486 449.803C185.715 449.957 186.026 449.896 186.18 449.667C186.334 449.438 186.273 449.127 186.044 448.973L182.724 446.742L184.955 443.422C185.109 443.193 185.048 442.882 184.819 442.728C184.59 442.574 184.279 442.635 184.125 442.864L181.615 446.599ZM594.765 366.283C594.919 366.054 594.858 365.743 594.629 365.589L590.894 363.079C590.665 362.925 590.354 362.986 590.2 363.215C590.046 363.445 590.107 363.755 590.336 363.909L593.656 366.14L591.425 369.46C591.271 369.69 591.332 370 591.561 370.154C591.79 370.308 592.101 370.247 592.255 370.018L594.765 366.283ZM182.126 447.369L184.58 446.887L184.388 445.906L181.934 446.387L182.126 447.369ZM189.489 445.924L194.397 444.962L194.205 443.98L189.296 444.943L189.489 445.924ZM199.306 443.999L204.215 443.036L204.022 442.055L199.114 443.018L199.306 443.999ZM209.123 442.073L214.032 441.111L213.839 440.129L208.931 441.092L209.123 442.073ZM218.94 440.148L223.849 439.185L223.656 438.204L218.748 439.166L218.94 440.148ZM228.757 438.222L233.666 437.259L233.474 436.278L228.565 437.241L228.757 438.222ZM238.575 436.297L243.483 435.334L243.291 434.353L238.382 435.315L238.575 436.297ZM248.392 434.371L253.3 433.408L253.108 432.427L248.199 433.39L248.392 434.371ZM258.209 432.446L263.117 431.483L262.925 430.501L258.016 431.464L258.209 432.446ZM268.026 430.52L272.935 429.557L272.742 428.576L267.834 429.539L268.026 430.52ZM277.843 428.594L282.752 427.632L282.559 426.65L277.651 427.613L277.843 428.594ZM287.66 426.669L292.569 425.706L292.376 424.725L287.468 425.688L287.66 426.669ZM297.478 424.743L302.386 423.78L302.194 422.799L297.285 423.762L297.478 424.743ZM307.295 422.818L312.203 421.855L312.011 420.874L307.102 421.836L307.295 422.818ZM317.112 420.892L322.02 419.929L321.828 418.948L316.919 419.911L317.112 420.892ZM326.929 418.967L331.838 418.004L331.645 417.022L326.736 417.985L326.929 418.967ZM336.746 417.041L341.655 416.078L341.462 415.097L336.554 416.06L336.746 417.041ZM346.563 415.115L351.472 414.153L351.279 413.171L346.371 414.134L346.563 415.115ZM356.38 413.19L361.289 412.227L361.097 411.246L356.188 412.209L356.38 413.19ZM366.198 411.264L371.106 410.302L370.914 409.32L366.005 410.283L366.198 411.264ZM376.015 409.339L380.923 408.376L380.731 407.395L375.822 408.357L376.015 409.339ZM385.832 407.413L390.74 406.45L390.548 405.469L385.639 406.432L385.832 407.413ZM395.649 405.488L400.558 404.525L400.365 403.544L395.457 404.506L395.649 405.488ZM405.466 403.562L410.375 402.599L410.182 401.618L405.274 402.581L405.466 403.562ZM415.283 401.636L420.192 400.674L419.999 399.692L415.091 400.655L415.283 401.636ZM425.1 399.711L430.009 398.748L429.817 397.767L424.908 398.73L425.1 399.711ZM434.918 397.785L439.826 396.823L439.634 395.841L434.725 396.804L434.918 397.785ZM444.735 395.86L449.643 394.897L449.451 393.916L444.542 394.878L444.735 395.86ZM454.552 393.934L459.46 392.971L459.268 391.99L454.359 392.953L454.552 393.934ZM464.369 392.009L469.278 391.046L469.085 390.065L464.177 391.027L464.369 392.009ZM474.186 390.083L479.095 389.12L478.902 388.139L473.994 389.102L474.186 390.083ZM484.003 388.158L488.912 387.195L488.719 386.213L483.811 387.176L484.003 388.158ZM493.821 386.232L498.729 385.269L498.537 384.288L493.628 385.251L493.821 386.232ZM503.638 384.306L508.546 383.344L508.354 382.362L503.445 383.325L503.638 384.306ZM513.455 382.381L518.363 381.418L518.171 380.437L513.262 381.4L513.455 382.381ZM523.272 380.455L528.181 379.492L527.988 378.511L523.079 379.474L523.272 380.455ZM533.089 378.53L537.998 377.567L537.805 376.586L532.897 377.548L533.089 378.53ZM542.906 376.604L547.815 375.641L547.622 374.66L542.714 375.623L542.906 376.604ZM552.723 374.679L557.632 373.716L557.44 372.734L552.531 373.697L552.723 374.679ZM562.541 372.753L567.449 371.79L567.257 370.809L562.348 371.772L562.541 372.753ZM572.358 370.827L577.266 369.865L577.074 368.883L572.165 369.846L572.358 370.827ZM582.175 368.902L587.083 367.939L586.891 366.958L581.982 367.921L582.175 368.902ZM591.992 366.976L594.446 366.495L594.254 365.514L591.8 365.995L591.992 366.976Z"
            fill="#FFFFFF99"
          />
        </g>
        <g id="A-Comp">
          <g filter="url(#filter4_d_5459_8525)">
            <rect
              id="A-Background"
              x="676.031"
              y="338.771"
              width="41"
              height="41"
              rx="20.5"
              transform="rotate(-174.18 676.031 338.771)"
              fill="transparent"
            />
            <path
              id="A-Text"
              d="M658.015 312.19L654.535 322.798H651.731L656.486 310.001H658.27L658.015 312.19ZM660.907 322.798L657.417 312.19L657.136 310.001H658.938L663.719 322.798H660.907ZM660.749 318.034V320.1H653.99V318.034H660.749Z"
              fill="#FFFFFF99"
            />
          </g>
          <path
            id="A-Line"
            d="M618.442 338.163C618.617 338.377 618.932 338.409 619.146 338.235L622.634 335.392C622.848 335.217 622.88 334.902 622.706 334.688C622.531 334.474 622.216 334.442 622.002 334.617L618.902 337.144L616.375 334.043C616.2 333.829 615.885 333.797 615.671 333.971C615.457 334.146 615.425 334.461 615.6 334.675L618.442 338.163ZM624.365 287.03C624.191 286.816 623.876 286.784 623.662 286.959L620.173 289.802C619.959 289.976 619.927 290.291 620.102 290.505C620.276 290.719 620.591 290.751 620.805 290.577L623.906 288.05L626.433 291.15C626.607 291.364 626.922 291.397 627.136 291.222C627.35 291.048 627.383 290.733 627.208 290.519L624.365 287.03ZM619.328 337.898L619.585 335.373L618.59 335.271L618.333 337.797L619.328 337.898ZM620.1 330.323L620.614 325.273L619.62 325.171L619.105 330.221L620.1 330.323ZM621.129 320.223L621.644 315.173L620.649 315.071L620.134 320.121L621.129 320.223ZM622.159 310.122L622.673 305.072L621.679 304.971L621.164 310.021L622.159 310.122ZM623.188 300.022L623.703 294.972L622.708 294.871L622.193 299.921L623.188 300.022ZM624.218 289.922L624.475 287.397L623.48 287.296L623.223 289.821L624.218 289.922Z"
            fill="#FFFFFF99"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_5459_8525"
          x="536.579"
          y="-6.95392"
          width="116.82"
          height="116.82"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="10" />
          <feGaussianBlur stdDeviation="15" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5459_8525" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_5459_8525"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_5459_8525"
          x="-0.266113"
          y="146.422"
          width="101.92"
          height="101.92"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="10" />
          <feGaussianBlur stdDeviation="15" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5459_8525" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_5459_8525"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_d_5459_8525"
          x="28.5176"
          y="328.227"
          width="113.632"
          height="113.632"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="10" />
          <feGaussianBlur stdDeviation="15" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5459_8525" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_5459_8525"
            result="shape"
          />
        </filter>
        <filter
          id="filter3_d_5459_8525"
          x="341.153"
          y="398.196"
          width="108.125"
          height="108.125"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="10" />
          <feGaussianBlur stdDeviation="15" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5459_8525" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_5459_8525"
            result="shape"
          />
        </filter>
        <filter
          id="filter4_d_5459_8525"
          x="605.243"
          y="273.825"
          width="104.946"
          height="104.946"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="10" />
          <feGaussianBlur stdDeviation="15" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5459_8525" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_5459_8525"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}

export default OneSeatOneBack
